import {
	OPEN_CONTEXT_MENU_FULFILLED,
	CLOSE_CONTEXT_MENU_FULFILLED
} from '../constants/contextMenu.actions';

export function closeContextMenu() {
	return {
		type: CLOSE_CONTEXT_MENU_FULFILLED,
		payload: null
	};
}

export function openContextMenu(x, y, contextMenu) {
	return {
		type: OPEN_CONTEXT_MENU_FULFILLED,
		payload: {
			x,
			y,
			contextMenu
		}
	};
}
